import ImageUpload from './ImageUpload.vue'
import VantImageUpload from './VantImageUpload.vue'

export class VImageUpload extends ImageUpload {}
export class VVantImageUpload extends VantImageUpload {}